
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexxGZ7tkr7CnY_45B5ZUoYf5AQJOqmkAeUcpdpYHDUglPX8Meta } from "/app/packages/main/pages/index.vue?macro=true";
import { default as logoutVnvqXxE6OioddKhQbJ38uKRH0Yl7fHbINCBxEqgxOwUMeta } from "/app/packages/main/pages/logout.vue?macro=true";
import { default as swaggeryPXFOYoeiwfyiLV68ttcB0gozwkRjcw8G4BGjZ2maIAMeta } from "/app/packages/main/pages/swagger.vue?macro=true";
import { default as meAT7KW7ScSdxNug_45aAq68LDhJTdeETkdVD3aZXeqdbEcMeta } from "/app/packages/main/pages/[client]/me.vue?macro=true";
import { default as indexAyYg98asd7HaVbYjMdV_45w0iT4k5VHkN90PiNbx9ZfrIMeta } from "/app/packages/main/pages/[client]/index.vue?macro=true";
import { default as indexBasmEyyoxscOsAQvTkieiZ5RHSaU2LplhEvTpGVJxpsMeta } from "/app/packages/main/pages/share/[shareId]/index.vue?macro=true";
import { default as _91_46_46_46path_93OmkED0X0lq_jLorQHsoUB4Gg9KbeKsrec5HsSCmpJiIMeta } from "/app/packages/main/pages/[client]/view/[...path].vue?macro=true";
import { default as _91_46_46_46path_93ySF01iVjqrms4QgiIND2cj5y9ftIOSDdzBrT5TNwOvgMeta } from "/app/packages/main/pages/[client]/write/[...path].vue?macro=true";
import { default as _91_46_46_46path_93ZOZ4ZR42U8ZbvM3iIKi3IAle6AdgYL_fUhaWon6_U_458Meta } from "/app/packages/main/pages/[client]/search/[...path].vue?macro=true";
import { default as infoKkaSrs0o4YICo697QqwI9UF53XcbiLQQTD2hM_45nup8sMeta } from "/app/packages/main/pages/[client]/administration/info.vue?macro=true";
import { default as indexRgQ0FI5wnIowwxVXEMpsD4_afH67uxJ9kbkP0hZVJqwMeta } from "/app/packages/main/pages/[client]/administration/index.vue?macro=true";
import { default as indexJY1ce_OOGs1kg_0d5OMwCNSGZK3OXU4b6aV7ALgtThsMeta } from "/app/packages/main/pages/manual/shared/[tenant]/[key]/index.vue?macro=true";
import { default as printxx4bSCqIMIjgMdbDaeexoJEbGYL2OHTkzZcQ4qpGJ04Meta } from "/app/packages/main/pages/manual/shared/[tenant]/[key]/print.vue?macro=true";
import { default as indexN7aGoP4p0PsNbdoRRtviDkqX3Dlfon9E14lpts8_45J_45QMeta } from "/app/packages/main/pages/[client]/administration/manual/index.vue?macro=true";
import { default as indexs2mMpMxQXxySKZ6_NUqpLm9B9B1MzwLrQg4VQNtde3YMeta } from "/app/packages/main/pages/[client]/administration/search/index.vue?macro=true";
import { default as indexVPwMrJ5i1oZOxj4fvwErlSNcMc9dUbjraO1n7plc7EkMeta } from "/app/packages/main/pages/[client]/administration/general/index.vue?macro=true";
import { default as indexfQ9Kyx2m4Xt31rPKtidgDwsfp1Ibaby6anoKPMjei34Meta } from "/app/packages/main/pages/[client]/administration/storage/index.vue?macro=true";
import { default as _91_46_46_46doc_93ClT2lN2j5ExuB9FZ23koACDGTN4O_jvJRvNfVTT3KyIMeta } from "/app/packages/main/pages/manual/shared/[tenant]/[key]/[...doc].vue?macro=true";
import { default as delete_45Fr30Nm0u1ul237gAXAsxOghGB2xlBravzKlPG6su6YMeta } from "/app/packages/main/pages/[client]/administration/general/delete.vue?macro=true";
import { default as indexytE6LoI_45VBmNb3Rmc3g_xzMzqSkTgKE6MZr_455Rl5UVQMeta } from "/app/packages/main/pages/[client]/administration/storage/link/[mode]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexxGZ7tkr7CnY_45B5ZUoYf5AQJOqmkAeUcpdpYHDUglPX8Meta || {},
    component: () => import("/app/packages/main/pages/index.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/app/packages/main/pages/logout.vue")
  },
  {
    name: "swagger",
    path: "/swagger",
    meta: swaggeryPXFOYoeiwfyiLV68ttcB0gozwkRjcw8G4BGjZ2maIAMeta || {},
    component: () => import("/app/packages/main/pages/swagger.vue")
  },
  {
    name: "client-me",
    path: "/:client()/me",
    meta: meAT7KW7ScSdxNug_45aAq68LDhJTdeETkdVD3aZXeqdbEcMeta || {},
    component: () => import("/app/packages/main/pages/[client]/me.vue")
  },
  {
    name: "client",
    path: "/:client()",
    component: () => import("/app/packages/main/pages/[client]/index.vue")
  },
  {
    name: "share-shareId",
    path: "/share/:shareId()",
    meta: indexBasmEyyoxscOsAQvTkieiZ5RHSaU2LplhEvTpGVJxpsMeta || {},
    component: () => import("/app/packages/main/pages/share/[shareId]/index.vue")
  },
  {
    name: "client-view-path",
    path: "/:client()/view/:path(.*)*",
    component: () => import("/app/packages/main/pages/[client]/view/[...path].vue")
  },
  {
    name: "client-write-path",
    path: "/:client()/write/:path(.*)*",
    component: () => import("/app/packages/main/pages/[client]/write/[...path].vue")
  },
  {
    name: "client-search-path",
    path: "/:client()/search/:path(.*)*",
    component: () => import("/app/packages/main/pages/[client]/search/[...path].vue")
  },
  {
    name: "client-administration-info",
    path: "/:client()/administration/info",
    meta: infoKkaSrs0o4YICo697QqwI9UF53XcbiLQQTD2hM_45nup8sMeta || {},
    component: () => import("/app/packages/main/pages/[client]/administration/info.vue")
  },
  {
    name: "client-administration",
    path: "/:client()/administration",
    meta: indexRgQ0FI5wnIowwxVXEMpsD4_afH67uxJ9kbkP0hZVJqwMeta || {},
    component: () => import("/app/packages/main/pages/[client]/administration/index.vue")
  },
  {
    name: "manual-shared-tenant-key",
    path: "/manual/shared/:tenant()/:key()",
    meta: indexJY1ce_OOGs1kg_0d5OMwCNSGZK3OXU4b6aV7ALgtThsMeta || {},
    component: () => import("/app/packages/main/pages/manual/shared/[tenant]/[key]/index.vue")
  },
  {
    name: "manual-shared-tenant-key-print",
    path: "/manual/shared/:tenant()/:key()/print",
    meta: printxx4bSCqIMIjgMdbDaeexoJEbGYL2OHTkzZcQ4qpGJ04Meta || {},
    component: () => import("/app/packages/main/pages/manual/shared/[tenant]/[key]/print.vue")
  },
  {
    name: "client-administration-manual",
    path: "/:client()/administration/manual",
    meta: indexN7aGoP4p0PsNbdoRRtviDkqX3Dlfon9E14lpts8_45J_45QMeta || {},
    component: () => import("/app/packages/main/pages/[client]/administration/manual/index.vue")
  },
  {
    name: "client-administration-search",
    path: "/:client()/administration/search",
    meta: indexs2mMpMxQXxySKZ6_NUqpLm9B9B1MzwLrQg4VQNtde3YMeta || {},
    component: () => import("/app/packages/main/pages/[client]/administration/search/index.vue")
  },
  {
    name: "client-administration-general",
    path: "/:client()/administration/general",
    meta: indexVPwMrJ5i1oZOxj4fvwErlSNcMc9dUbjraO1n7plc7EkMeta || {},
    component: () => import("/app/packages/main/pages/[client]/administration/general/index.vue")
  },
  {
    name: "client-administration-storage",
    path: "/:client()/administration/storage",
    meta: indexfQ9Kyx2m4Xt31rPKtidgDwsfp1Ibaby6anoKPMjei34Meta || {},
    component: () => import("/app/packages/main/pages/[client]/administration/storage/index.vue")
  },
  {
    name: "manual-shared-tenant-key-doc",
    path: "/manual/shared/:tenant()/:key()/:doc(.*)*",
    meta: _91_46_46_46doc_93ClT2lN2j5ExuB9FZ23koACDGTN4O_jvJRvNfVTT3KyIMeta || {},
    component: () => import("/app/packages/main/pages/manual/shared/[tenant]/[key]/[...doc].vue")
  },
  {
    name: "client-administration-general-delete",
    path: "/:client()/administration/general/delete",
    meta: delete_45Fr30Nm0u1ul237gAXAsxOghGB2xlBravzKlPG6su6YMeta || {},
    component: () => import("/app/packages/main/pages/[client]/administration/general/delete.vue")
  },
  {
    name: "client-administration-storage-link-mode",
    path: "/:client()/administration/storage/link/:mode()",
    meta: indexytE6LoI_45VBmNb3Rmc3g_xzMzqSkTgKE6MZr_455Rl5UVQMeta || {},
    component: () => import("/app/packages/main/pages/[client]/administration/storage/link/[mode]/index.vue")
  }
]